import Reflux from 'reflux';

import formActions from '../actions/form-actions';

export default Reflux.createStore({
	init: function () {
		this.listenToMany(formActions);
		this.onReset();
	},

	onReset: function () {
		this._state = {
			selectedFilterOptionName: null,
			selectedFilterOption: null,
			selectedAdditionalFilterOptionName: null,
			selectedAdditionalFilterOption: null,
			searchTerm: null,
		};
		this.trigger(this._state);
	},

	onSelectFilter: function (key, value) {
		this._state.selectedFilterOptionName = key;
		this._state.selectedFilterOption = value;
		this._state.searchTerm = null;
		this._state.filterOpen = false;
		// if we unset the filter (show all), we also unset the additional filter
		if (!key) {
			this._state.selectedAdditionalFilterOptionName = null;
			this._state.selectedAdditionalFilterOption = null;
		}
		this.trigger(this._state);
	},

	onSelectAdditionalFilter: function (key, value) {
		this._state.selectedAdditionalFilterOptionName = key;
		this._state.selectedAdditionalFilterOption = value;
		this.trigger(this._state);
	},

	onSearch: function (searchTerm) {
		this._state.selectedFilterOptionName = null;
		this._state.selectedFilterOption = null;
		this._state.selectedAdditionalFilterOptionName = null;
		this._state.selectedAdditionalFilterOption = null;
		this._state.searchTerm = searchTerm;
		this.trigger(this._state);
	},

	onOpenFilter: function () {
		this._state.filterOpen = true;
		this.trigger(this._state);
	},

	onCloseFilter: function () {
		this._state.filterOpen = false;
		this.trigger(this._state);
	},

	getInitialState: function () {
		return this._state;
	},
});
